import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import getQueryParameter from '../../../utils/getQueryParameter';

const ConsumerRegisterFailure: React.FunctionComponent = () => {
  const location = useLocation();

  const isRegisterError = location.pathname.indexOf('/rekisteroidy') !== -1;
  const error = getQueryParameter(location.search, 'error');

  let errorText = '';
  switch (error) {
    case 'access_denied':
      errorText = 'Tunnistautuminen keskeytetty';
      break;
    case 'state':
    case 'fatal':
    default:
      errorText = 'Tunnistautuminen epäonnistui';
      break;
  }

  return (
    <div className="wrapper">
      <h1>{errorText}</h1>
      <NavLink to={isRegisterError ? '/rekisteroidy/aloita' : '/palauta'}>
        <button className="submit">
          {isRegisterError ? 'Rekisteröidy palveluun' : 'Vaihda salasana'}
        </button>
      </NavLink>
    </div>
  );
};

export default ConsumerRegisterFailure;
